function getURLVar(key) {
  var value = [];

  var query = String(document.location).split('?');

  if (query[1]) {
    var part = query[1].split('&');

    for (i = 0; i < part.length; i++) {
      var data = part[i].split('=');

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
}
function isEmpty( el ){
  return !$.trim(el.html())
}
$(document).ajaxStop(function() {
  function isEmpty( el ){
    return !$.trim(el.html())
  }
  if (!isEmpty($('#product'))) {
    $('#product').addClass('has-option');      
  }	
});
// function divWidthMenu() {
// var width_br = $(".container-fix .block-right").outerWidth();
// var width_count = $(".container-fix").width();
// var width_bl = $("#logo img").outerWidth();
// $('.container-fix .main-menu').outerWidth(width_count-width_bl-width_br-30);
// }
function customResponsive(){
  var window_w = parseInt($(window).width());

  $('#blog_home .row_items').each(function(){
    $('#blog_home .row_items .articles-inner').css({'width':($('#blog_home .owl-wrapper-outer').width()-30)/100*50, 'float': 'left'});
    $('#blog_home .row_items .articles-inner:first-child').css('width',($('#blog_home .owl-wrapper-outer').width()-30)/100*25);
    $('#blog_home .row_items .articles-inner:last-child').css('width',($('#blog_home .owl-wrapper-outer').width()-30)/100*25);
  });

  // $("#logo img").each(function() {
  // if( this.complete ) {
  // divWidthMenu.call( this );
  // } else {
  // $(this).one('load', divWidthMenu);
  // }
  // });
}
$(window).resize(function() {
  customResponsive();
});


// sticky menu
function stickyMenu(){
  var winInnW = window.innerWidth;
  var winScrT = $(window).scrollTop();
  var s0w991  = winScrT>300 && winInnW>1024;
  var headerSpaceH = $('.container-fix').outerHeight(true);
  var scroll = $(window).scrollTop();
  var currentP = 0;
  stickyOffset = $('header').outerHeight(true);

  $('.headerSpace').remove();	
  $('.container-fix').after('<div class="headerSpace unvisible" style="height: '+headerSpaceH+'px;" ></div>');	
  if(scroll != currentP){
    if(winInnW>1024){
      if(winScrT>stickyOffset){
        $('.container-fix').addClass('fix-header');			
        $('.headerSpace').removeClass('unvisible');
      } else{
        $('.container-fix').removeClass('fix-header');
        $('.headerSpace').addClass('unvisible');
      }
    } else{
      $('.container-fix').removeClass('fix-header');
      $('.headerSpace').addClass('unvisible');
    }
  } 
  currentP = $(window).scrollTop();
}
//stickyMenu();
$(window).on('resize scroll', stickyMenu);
$(document).ready(function() {	
  if ($(".category-des").length == 0) {
    $('.toolbar').addClass('mtop');
  }
  if ($(".hd3").length) {
    $('.wrapper').addClass('hd3');
  }
  if ($(".hd4").length) {
    $('.wrapper').addClass('hd4');
  }
  // vertical thumbs on product page
  
  
  
  // product video 
  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  // color swatch js snippet
  $('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });

  // product page add to cart
  $('#button-cart').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input[type=\'text\'], #form_buy select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart').button('loading');
      },
      complete: function() {
        $('#button-cart').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        toastr.success('Congratulation! Item added successfully.')

        $.getJSON('/cart.js', function(cart) {
          $('#cart-total').html(cart.item_count);
          Currency.convertAll(shopCurrency, Currency.cookie.read());
        });

        //$('html, body').animate({ scrollTop: 0 }, 'slow');

        $('#cart > ul').load('/ #cart > ul li');

      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      }
    });
  });


  $('.container-fix').hover(function(){ 
    $(this).addClass("fix-header-act");
  },function(){ 
    $(this).removeClass("fix-header-act");
  });

  customResponsive();

  if (!isEmpty($('#product'))) {
    $('#product').addClass('has-option');      
  }
  if (!isEmpty($('#product2'))) {
    $('#product2').addClass('has-option');      
  }

  // move breadcrumbs
  $("body.collection header").append('<div class="breadcrumbs"><div class="container"></div></div>');	
  var breadcrumb = $('ul.breadcrumb');
  var breadcrumbs_container = $('.breadcrumbs .container');
  breadcrumb.appendTo(breadcrumbs_container);
  $("body.collection .breadcrumb").before($('.category-name'));


  // Highlight any found errors
  $('.text-danger').each(function() {
    var element = $(this).parent().parent();

    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

  /* Search */
  $('#search input[name=\'q\']').parent().find('button').on('click', function() {
    var url = '/search';
    var value = $('#search input[name=\'q\']').val();
    if(value == "Search all products..." || value ==""){
      jQuery('#search input[name=\'q\']').focus();
      return false;
    }else {
      url += '?type=product&q=' + encodeURIComponent(value);
    }
    location = url;
  });

  $('#search input[name=\'q\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('#search input[name=\'q\']').parent().find('button').trigger('click');
    }
  });

  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();

    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());

    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });

  // Product List
  $('#list-view').click(function() {
    $('.custom-products').removeClass('custom-products-row');
    $(this).addClass('selected');
    $('#grid-view').removeClass('selected');
    $('#content .product-grid > .clearfix').remove();

    //$('#content .product-layout').attr('class', 'product-layout product-list col-xs-12');
    $('#content .product-grid').attr('class', 'product-layout product-list col-xs-12');
    $('#content .product-list .product-inner').addClass('col-xs-8');
    $('#content .product-list .image').addClass('col-xs-4');


    localStorage.setItem('display', 'list');
  });

  // Product Grid
  $('#grid-view').click(function() {
    $('.custom-products').addClass('custom-products-row');
    $(this).addClass('selected');
    $('#list-view').removeClass('selected');
    // What a shame bootstrap does not take into account dynamically loaded columns
    cols = $('#column-right, #column-left').length;

    if (cols == 2) {
      $('#content .product-layout').attr('class', 'product-layout product-grid col-md-6 col-sm-6 col-xs-6 two-items');
    } else if (cols == 1) {
      $('#content .product-layout').attr('class', 'product-layout product-grid col-md-4 col-sm-6 col-xs-6 three-items');
    } else {
      $('#content .product-layout').attr('class', 'product-layout product-grid col-md-3 col-sm-6 col-xs-6 four-items');
    }
    $('#content .product-grid .product-inner').removeClass('col-xs-8');
    $('#content .product-grid .image').removeClass('col-xs-4');


    localStorage.setItem('display', 'grid');
  });
  if (localStorage.getItem('display') == null) {
    $('#list-view').trigger('click');
      } else if (localStorage.getItem('display') == 'grid') {
      $('#grid-view').trigger('click');
    } else {
      $('#list-view').trigger('click');
    }

    // Checkout
    $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
      if (e.keyCode == 13) {
        $('#collapse-checkout-option #button-login').trigger('click');
      }
    });

    // tooltips on hover
    $('[data-toggle=\'tooltip\']').tooltip({container: 'body', animation: false});

    // Makes tooltips work on ajax generated content
    $(document).ajaxStop(function() {
      $('[data-toggle=\'tooltip\']').tooltip({container: 'body', animation: false});
    });
  });

  // Cart add remove functions

  // Cart add remove functions
  var cart = {
    'add': function(product_id, quantity) {
      $.ajax({
        url: '/cart/add.js',
        type: 'post',
        data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
        dataType: 'json',
        beforeSend: function() {
          var btn = $(this);
          $('.btn-cart > .button').button('loading');
        },
        complete: function() {
          $('.btn-cart > .button').button('reset');
        },
        success: function(json) {
          $('.alert, .text-danger').remove();

          if (json['redirect']) {
            location = json['redirect'];
          }

          toastr.success('Congratulation! Your item has been added.')

          $.getJSON('/cart.js', function(cart) {
            setTimeout(function () {
              $('#cart-total').html(cart.item_count);
            }, 100);
            //Currency.convertAll(shopCurrency, Currency.cookie.read());
          });

          $('#cart > ul').load('/ #cart > ul li');
        },
        error: function(xhr, ajaxOptions, thrownError) {
          alert(xhr.responseText);
        }
      });
    },
    'remove': function(key) {
      $.ajax({
        url: '/cart/update.js',
        type: 'post',
        data: 'updates['+key+']=0',
        dataType: 'json',
        beforeSend: function() {
          //$('#cart > button').button('loading');
        },
        success: function(json) {
          $('#cart > button').button('reset');
          setTimeout(function () {
            $('#cart-total').html(json['item_count']);
          }, 100);
          //Currency.convertAll(shopCurrency, Currency.cookie.read());

          if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout') {
            location = '/cart';
          } else {
            $('#cart > ul').load('/ #cart > ul li');
          }
        },
        error: function(xhr, ajaxOptions, thrownError) {
          alert(xhr.responseText);
        }
      });
    }
  }

  /* Agree to Terms */
  $(document).delegate('.agree', 'click', function(e) {
    e.preventDefault();

    $('#modal-agree').remove();

    var element = this;

    $.ajax({
      url: $(element).attr('href'),
      type: 'get',
      dataType: 'html',
      success: function(data) {
        html  = '<div id="modal-agree" class="modal">';
        html += '  <div class="modal-dialog">';
        html += '    <div class="modal-content">';
        html += '      <div class="modal-header">';
        html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
        html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
        html += '      </div>';
        html += '      <div class="modal-body">' + data + '</div>';
        html += '    </div';
        html += '  </div>';
        html += '</div>';

        $('body').append(html);

        $('#modal-agree').modal('show');
      }
    });
  });

  // Autocomplete */
  (function($) {
    $.fn.autocomplete = function(option) {
      return this.each(function() {
        this.timer = null;
        this.items = new Array();

        $.extend(this, option);

        $(this).attr('autocomplete', 'off');

        // Focus
        $(this).on('focus', function() {
          this.request();
        });

        // Blur
        $(this).on('blur', function() {
          setTimeout(function(object) {
            object.hide();
          }, 200, this);
        });

        // Keydown
        $(this).on('keydown', function(event) {
          switch(event.keyCode) {
            case 27: // escape
              this.hide();
              break;
            default:
              this.request();
              break;
          }
        });

        // Click
        this.click = function(event) {
          event.preventDefault();

          value = $(event.target).parent().attr('data-value');

          if (value && this.items[value]) {
            this.select(this.items[value]);
          }
        }

        // Show
        this.show = function() {
          var pos = $(this).position();

          $(this).siblings('ul.dropdown-menu').css({
            top: pos.top + $(this).outerHeight(),
            left: pos.left
          });

          $(this).siblings('ul.dropdown-menu').show();
        }

        // Hide
        this.hide = function() {
          $(this).siblings('ul.dropdown-menu').hide();
        }

        // Request
        this.request = function() {
          clearTimeout(this.timer);

          this.timer = setTimeout(function(object) {
            object.source($(object).val(), $.proxy(object.response, object));
          }, 200, this);
        }

        // Response
        this.response = function(json) {
          html = '';

          if (json.length) {
            for (i = 0; i < json.length; i++) {
              this.items[json[i]['value']] = json[i];
            }

            for (i = 0; i < json.length; i++) {
              if (!json[i]['category']) {
                html += '<li data-value="' + json[i]['value'] + '"><a href="#">' + json[i]['label'] + '</a></li>';
              }
            }

            // Get all the ones with a categories
            var category = new Array();

            for (i = 0; i < json.length; i++) {
              if (json[i]['category']) {
                if (!category[json[i]['category']]) {
                  category[json[i]['category']] = new Array();
                  category[json[i]['category']]['name'] = json[i]['category'];
                  category[json[i]['category']]['item'] = new Array();
                }

                category[json[i]['category']]['item'].push(json[i]);
              }
            }

            for (i in category) {
              html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';

              for (j = 0; j < category[i]['item'].length; j++) {
                html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
              }
            }
          }

          if (html) {
            this.show();
          } else {
            this.hide();
          }

          $(this).siblings('ul.dropdown-menu').html(html);
        }

        $(this).after('<ul class="dropdown-menu"></ul>');
        $(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));

      });
    }
  })(window.jQuery);